import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getLawDetailById } from '@/api/law';
import SvgIcon from '@/components/svg-icon.vue';
export default {
  components: {
    SvgIcon: SvgIcon
  },
  props: {
    dataList: {
      type: Array,
      default: function _default() {
        return [];
      } // 所有的法规信息
    }
  },
  data: function data() {
    return {
      lawIdList: [],
      // 法规ID列表(返回上一条用)
      visible: false,
      pagination: {
        // 分页
        current: 0,
        size: 5
      },
      visibleList: [],
      // 可视法规列表
      lawInfo: {} // 法规信息
    };
  },
  watch: {
    visible: {
      handler: function handler(val) {
        if (!val) {
          this.lawInfo = {};
          this.lawIdList = [];
        }
      }
    },
    dataList: {
      handler: function handler(val) {
        this.visibleList = val.slice(0, this.pagination.size);
      }
    }
  },
  methods: {
    previous: function previous() {
      this.lawIdList.splice(-1); // 删除最后一条
      var id = this.lawIdList[this.lawIdList.length - 1];
      this.requestLawInfo(id, 'back');
    },
    /**
     * 查看法规详情
     * （注：根据法规嵌套合规AI的地址上加上from=pc或者from=h5区分，如果是pc,通知法规库在新的标签页打开法规详情）
     * @param url
     */
    viewLawDetail: function viewLawDetail(url) {
      var id = url.split('?id=')[1];
      // 如果是PC端向父页面发送消息
      if (this.$route.query.from === 'pc') {
        window.parent.postMessage({
          type: 'LAW_POST_MESSAGE',
          id: id
        }, '*'); // 生产环境中应将'*'替换为具体的父页面Origin
      } else {
        // 如果是H5移动端则打弹出框显示
        this.requestLawInfo(id);
        this.visible = true;
      }
    },
    requestLawInfo: function requestLawInfo(id) {
      var _this = this;
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'next';
      getLawDetailById({
        id: id,
        isShare: 1
      }).then(function (_ref) {
        var data = _ref.data;
        if (opt !== 'back') {
          _this.lawIdList.push(id);
        }
        _this.lawInfo = data;
        /**
         * 为什么 setTimeout 有效？
         * • JavaScript 是单线程的，setTimeout 会将回调放入任务队列
         * • 浏览器会在当前执行栈清空后执行任务队列中的回调
         * • 这时浏览器已经完成了HTML的解析和渲染
         * • 即使设置为0ms，也能确保在DOM更新后执行
         */
        setTimeout(function () {
          // 禁止跳转
          _this.$nextTick(function () {
            var links = document.querySelectorAll('a'); // 获取所有的a标签
            links.forEach(function (link) {
              // 为每个a标签添加点击事件监听器
              link.addEventListener('click', function (event) {
                event.preventDefault(); // 阻止默认行为，即阻止链接跳转
                var href = link.getAttribute('href');
                if (!href.includes('http')) {
                  // 阻止跳转到第三方网页
                  _this.requestLawInfo(href, 'next');
                }
              });
            });
          });
        }, 0);
      });
    },
    /**
     * 上一页
     */
    preHandler: function preHandler() {
      this.pagination.current -= 1;
      var startIndex = this.pagination.current * this.pagination.size;
      this.visibleList = this.dataList.slice(startIndex, startIndex + this.pagination.size);
    },
    /**
     * 下一页
     */
    nextHandler: function nextHandler() {
      this.pagination.current += 1;
      var startIndex = this.pagination.current * this.pagination.size;
      this.visibleList = this.dataList.slice(startIndex, startIndex + this.pagination.size);
    }
  }
};